import './Footer.css';

export default function Footer({label}) {
    return (
        <footer className={label}>
            <p><a href='https://github.com/joekgilberto/blu-rave' target='_blank'>Blu-Rave</a> is a full-stack application built by <a href='https://joekgilberto.com/' target='_blank'>Joe Gilberto</a> using <a href='https://dotnet.microsoft.com/en-us/apps/aspnet' target='_blank'>ASP.NET</a>, <a href='https://react.dev/' target='_blank'>React</a>, <a href='https://www.postgresql.org/' target='_blank'>PostgreSQL</a>, and <a href='https://auth0.com/' target='_blank'>Auth0</a>.</p>
        </footer>
    );
}